"use strict";

define('view/meeting.summary',['marionette', 'moment', 'uikit/mixins/component.mixin', 'uikit/elements/button', '../templates', '../libs/moment-precise-diff'], function (Mn, moment, ComponentMixin, ButtonView, Templates) {
  var MeetingSummary = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.IRB['meeting.summary'],
    attributes: {
      style: 'min-width: 150px;'
    },
    format: {
      time: 'LT'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.format = _.extend({}, this.format, this.options.format);
      this.more = new ButtonView({
        text: 'View Details',
        size: 'tiny',
        fluid: true,
        color: 'primary',
        model: this.model
      }).on('press', function () {
        this.triggerMethod('more:press');
      }, this);
      this.agenda = new ButtonView({
        text: 'View Agenda',
        size: 'tiny',
        fluid: true,
        color: 'primary',
        target: '_blank',
        model: this.model
      });
    },
    onChangeModel: function onChangeModel() {
      if (this.more) {
        this.more.model = this.model;
      }
      if (this.agenda && this.model) {
        this.agenda.model = this.model;
        this.agenda.link = '/rs/api/meeting/agenda/' + this.model.id;
      } else if (this.agenda) {
        this.agenda.model = null;
        this.agenda.link = null;
      }
    },
    serializeData: function serializeData() {
      var data = Mn.ItemView.prototype.serializeData.apply(this, arguments);
      data.startTime = moment(data.startDate).format(this.format.time);
      data.endTime = moment(data.endDate).format(this.format.time);
      data.duration = moment(data.endDate).preciseDiff(data.startDate);
      return data;
    }
  });
  return MeetingSummary;
});

